<template>
    <!-- <div id="app" style="overflow-y: auto;"> -->
    <div id="app">
        <!-- <img src="./assets/logo.png"> -->
        <router-view />
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ConstJson from "../src/api/common/constjson.js"
// import VueCookies from 'vue-cookies'
import store from './store'
import eventBus from "./components/common/event_bus.js"
let constJ = new ConstJson()
export default {
    name: 'App',
    data(){
        return {
        }
    },
    created: function() {
        console.log("app...")
        //设置文件夹测试数据
        // this.getAllFolder()
        //let screenWidth = screen.width + "," + screen.height
        //console.log(screenWidth)
        //console.log('innerHeight:'+height)
        this.load();
        store.state.user.sysconfig.pages = this.$baseConfig.pages
        //store.state.user.folder.data=this.initFolder()
        //console.log(store.state.user.folder.data)
        // console.log('pages:'+store.state.user.sysconfig.pages)
        //console.log(this.$baseConfig)
        //var that =this

        //获取locainfo,暂未开放
        //console.log("status:"+store.state.user.localinfo.status)

        // if (store.state.user.localinfo.status === undefined) {
        //     this.$API.GetIP().then(res => {
        //         console.log(res.data)
        //         if (res.data.status === "success") {
        //             let strP = res.data
        //             store.state.user.localinfo = strP
        //         }
        //     }).catch(err => {
        //         console.log(err)
        //         return
        //     })
        // }



        // if(sessionStorage.st!==undefined){
        //   let loginUser=JSON.parse(sessionStorage.st)
        //   store.commit('setLoginUser', loginUser)
        // }
        // console.log("session:"+store.state.user.userId)

    },
    mounted() {
        eventBus.$on('login-cannel', () => {
            console.log("login-cannel...")

            //this.load()
        })
        // eventBus.$on('login-cannel', value => {
        //   console.log("login-cannel...",value)
        // })
    },

    methods: {
        temploginreload() {
            console.log("temploginok...")
        },
        handle_tmpLogin() {
            //console.log(this.sta.isLogin)
            this.handleTempLogin()
                .then(res => {
                    console.log(res)
                    console.log("临时用户登录成功app,login:" + this.sta.isLogin)
                    //console.log(this.sta)
                    this.handle_lefttree()
                    //this.handle_lefttmtree()
                    this.handle_industry()
                    this.handle_taxes()
                    this.handle_inOut()
                    this.handle_Reduction()
                    this.handle_Reduction_tax()
                    this.handle_Reduction_industry()
                    this.handle_country()
                    this.handle_ProvinceAndCity()
                    this.handle_OffersIndustry()
                    //this.$router.push({path:'/main'});
                    //this.$router.go('/main/searchengine');
                    //this.$router.push({path: '/main/searchengine/search'});
                    // let data = sessionStorage.getItem('st');
                    // console.log(data)
                    //通知修改登录
                    //console.log(this.sta.mobileNum)

                    //更新临时登录状态
                    // if (this.sta.mobileNum !== '' || this.sta.accounttype === 0) {
                    //     eventBus.$emit("update-loginState", "true")
                    // }


                    //upload
                    //this.upload(store.state.user.localinfo)

                    //判断是否是微信注册
                    if (store.state.user.wxcode !== '' && store.state.user.wxstate !== '' && store.state.user.iswxreg) {
                        //微信注册
                        let po = {
                            code: store.state.user.wxcode,
                            state: store.state.user.wxstate,
                            tempuserid: store.state.user.userGuid
                        }
                        //this.weixinReg(po)
                        this.weixinRegV2(po)

                    } else if (store.state.user.wxcode !== '' && store.state.user.wxstate !== '' && store.state.user.iswxbind) {
                        //微信绑定
                        let po = {
                            code: store.state.user.wxcode,
                            state: store.state.user.wxstate,
                            tempuserid: store.state.user.userGuid
                        }
                        this.weixinBind(po)
                    } else if (store.state.user.wxcode !== '' && store.state.user.wxstate !== '') {
                        //微信登录
                        let po = {
                            code: store.state.user.wxcode,
                            state: store.state.user.wxstate,
                            tempuserid: store.state.user.userGuid
                        }
                        this.weixinLogin(po)
                    }
                    // console.log(store.state.user.wxcode, store.state.user.wxstate, store.state.user.userGuid)
                    
                    //console.log(this.$router.currentRoute)
                    //jxt特别导航
                    if(this.$router.currentRoute.query.g){
                        console.log("jxt特别导航=====>")
                        console.log(this.$router.currentRoute.query.g)
                        console.log(this.$router.currentRoute.query.t)
                        store.state.user.isjxt=true
                        var modultype = this.$router.currentRoute.query.g
                        var pass_token = this.$router.currentRoute.query.t
                        var payload = {
                            xtoken: pass_token,
                        } 
                        setTimeout(()=>{
                            store._actions.tokenLogin[0](payload)
                            .then(res => {
                                console.log("token登录成功，开始重定向===>")
                            })
                            .catch(err => {
                                console.log("token登录失败，游客身份重定向===>")
                                console.log(err)
                            })  
                        },200)

                        switch (modultype) {
                            case "1":
                                this.$router.push('localsearch')
                                break;
                            case "2":
                                this.$router.push('jdsearch')
                                break;
                        }
                        
                       
                    }else{
                        console.log("正常导航=====>")
                        store.state.user.isjxt=false
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        checkIsWxUser(po) {
            this.$Modal.confirm({
                title: '提示',
                content: '<p>系统检测到您尚未注册账号，是否注册？</p>',
                cancelText: "否",
                okText: '是',
                onOk: () => {
                    //this.weiXinRegAndLogin(po)
                    this.weixinRegV2(po)
                },
                onCancel: () => {
                    return
                }
            });
        },
        //绑定微信
        weixinBind(po) {
            constJ.reqBindWX(po).then(res => {
                console.log(res)
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        this.$Message.success("微信关联成功")
                        //刷新token，更新用户登录状态
                        setTimeout(() => {
                            eventBus.$emit('user-reload-update')
                        }, 1000)
                    } else {
                        console.log(res.rltdesc)
                        this.$Message.warning(res.rltdesc)
                        //eventBus.$emit('user-flashToken')
                        setTimeout(() => {
                            eventBus.$emit("update-loginState")
                        }, 1000)
                        return
                    }
                } else {
                    console.log(res.rtndesc)
                    this.$Message.warning(res.rltdesc)
                    return
                }
            })
        },

        //微信登录
        weixinLogin(po) {
            constJ.reqWXLogin(po).then(res => {
                console.log(res)
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //登录成功
                        //刷新登录数据
                        this.updateUser(res)
                        //如果已经是微信注册用户且购买了会员等级，弹出提示是否修改账号(前三天每天登录提示)

                    } else if (res.rltcode === -3) {
                        //注册并登录
                        this.checkIsWxUser(po)
                    } else {
                        console.log(res.rltdesc)
                        this.$Modal.info({
                            title: '提示',
                            content: res.rltdesc
                        });
                        //this.$Message.warning(res.rltdesc)
                        return
                        //reject(res.rltdesc)
                    }
                } else {
                    console.log(res.rtndesc)
                    this.$Modal.info({
                        title: '提示',
                        content: res.rtndesc
                    });
                    //this.$Message.warning(res.rltdesc)
                    return
                    //reject(res.rtndesc)
                }
            })
        },
        weiXinRegAndLogin(po) {
            constJ.reqWXRegAndLogin(po).then(res => {
                console.log(res)
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //提示是否注册
                        this.$Message.warning('微信注册成功')
                        //刷新登录数据
                        this.updateUser(res)

                    } else {
                        console.log(res.rltdesc)
                        this.$Message.warning(res.rltdesc)
                        return
                        //reject(res.rltdesc)
                    }
                } else {
                    console.log(res.rtndesc)
                    this.$Message.warning(res.rltdesc)
                    return
                    //reject(res.rtndesc)
                }
            })
        },
        //检测是否注册微信并提示是否登录
        checkIsWxRegUser(po) {
            this.$Modal.confirm({
                title: '提示',
                content: '<p>系统检测到您已完成微信注册，是否登录？</p>',
                cancelText: "否",
                okText: '是',
                onOk: () => {
                    this.weixinLogin(po)
                },
                onCancel: () => {
                    return
                }
            });
        },
        //微信注册成功，提示是否登录
        checkWxLogin(po) {
            this.$Modal.confirm({
                title: '提示',
                content: '<p>微信注册成功，是否登录？</p>',
                cancelText: "否",
                okText: '是',
                onOk: () => {
                    this.weixinLogin(po)
                },
                onCancel: () => {
                    return
                }
            });
        },

        //拉起扫码注册逻辑
        weixinRegV2(po) {
            //拉起注册逻辑
            this.$nextTick(() => {
                eventBus.$emit("user-wexin-reg", po)
            })
        },

        //微信注册(无需收集行业信息)
        weixinReg(po) {
            constJ.reqWXReg(po).then(res => {
                console.log(res)
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        if (res.message === "您已注册") {
                            // this.$Message.warning()
                            this.checkIsWxRegUser(po)
                        }
                        if (res.message === "注册成功") {
                            this.checkWxLogin(po)
                        }

                    } else {
                        this.$Message.warning(res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.warning(res.rtndesc)
                    return
                }
            })
        },
        //更新登陆数据
        updateUser(res, isWxMember = false) {
            var wxLoginUser = {
                userGuid: res.userguid,
                userId: res.userid,
                mobileNum: res.mobilenum,
                realName: res.realname,
                token: res.token,
                userType: res.userid, //手动登录成功，将用户id写入userType,以区别临时用户,普通用户和企业用户
                //accounttype: res.accounttype, //  0-临时用户, 1-个人用户,2-单位用户, 3-单位用户(固定IP),4-团购用户
                permission: res.permission,
                accounttype: res.accounttype,
                accountstatus: res.accountstatus,
                freefolder: res.freefolder,
                showmsg: res.showmsg,
                wxopenid: res.wxopenid,
                wxunionid: res.wxunionid,
                wxgenerateid: res.wxgenerateid,
                showmallbutton: res.showmallbutton,
                mallver: res.mallver,
                iseditacc: res.isallowedituserid,
                isupbaseproductnotice:res.isupbaseproductnotice,
                maxopendocnum:res.maxopendocnum,
                opendocnum:res.opendocnum,
                email:res.email
            }
            store.commit('setLoginUser', wxLoginUser)
            //第一个true=是否更新登录状态，第二true=是否拉起修改账号
            eventBus.$emit("update-loginState", isWxMember)
        },
        load() {
            //临时登录入口
            console.log('userId:' + this.sta.userId, 'accounttype:' + this.sta.accounttype)
            if (this.sta.userId !== '' || this.sta.accounttype !== 0) {
                //console.log("loading...")
                // VueCookies.set("head","gooo")
            } else {
                this.handle_tmpLogin()
            }
        },
        initUserFolder() {
            constJ.reqCreateDefault().then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        console.log('session登录成功,初始化文件夹')
                        //this.getFixedFolder()
                        this.getFolderTree()
                        console.log(res)
                        //this.handleSetTree(res.datas)
                    } else {
                        console.log(res.rltdesc)
                        //reject(res.rltdesc)
                    }
                } else {
                    console.log(res.rtndesc)
                    //reject(res.rtndesc)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        getAllFolder() {
            console.log('getAllFolder====>')
            store.state.user.myfolders = [{
                value: '1',
                title: '全部文件归档',
                expand: true,
                _select: false,
                children: [{
                        value: '2',
                        title: '文件夹二',
                        expand: true,
                        _select: false,
                        children: [{
                                value: '3',
                                title: '文件夹三',
                                expand: true,
                                _select: false,
                            },
                            {
                                value: '4',
                                title: '文件夹四',
                                expand: true,
                                _select: false,
                            }
                        ]
                    },
                    {
                        value: '5',
                        title: '文件夹五',
                        expand: true,
                        _select: false,
                        children: [{
                                value: '6',
                                title: '文件夹六',
                                expand: true,
                                _select: false,
                            },
                            {
                                value: '7',
                                title: '文件夹七',
                                expand: true,
                                _select: false,
                            }
                        ]
                    }
                ]
            }]
            console.log(store.state.user.myfolders)
        },

        //*****************************************************************************
        //获取全量文件夹树
        //修改key
        changeTreeDate(jsonObj, newKey, oldKey) {
            let str = JSON.stringify(jsonObj);
            let reg = new RegExp(oldKey, 'g');
            let newStr = str.replace(reg, newKey);
            return JSON.parse(newStr);
        },
        //递归增加expand,_select,默认为false
        addAttribute(childrens) {
            childrens.forEach(item => {
                if (item.is_root) {
                    //展开第一层
                    item.expand = true
                    item._select = false
                } else {
                    item.expand = false
                    item._select = false
                }

                if (item.children && item.children.length > 0) {
                    this.addAttribute(item.children)
                }
            })
        },
        //获取文件夹树
        getFolderTree() {
            constJ.reqGetFolderTree().then(res => {
                console.log('getFolderTree==>')
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //修改根节点
                        if (res.data.tree.is_root) {
                            res.data.tree.dir_name = '全部文件归档'
                        }
                        // this.folderNumbersUsed = res.data.numberoffolders
                        var data = []
                        data.push(res.data.tree)
                        //处理数据1，修改key name：title，value
                        let data_tree = this.changeTreeDate(data, 'title', 'dir_name')
                        data_tree = this.changeTreeDate(data_tree, 'value', 'dir_id')
                        //递归增加属性expand，_select
                        this.addAttribute(data_tree)
                        var str = JSON.stringify(data_tree)
                        let _data = JSON.parse(str)
                        //更新数据
                        store.state.user.myfolders = _data
                    }
                }
            })
        },
        //*****************************************************************************

        getFixedFolder() {
            constJ.reqGetFixedFolder().then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        console.log('开始获取固定文件夹..')
                        console.log(res)
                        let folderData = this.setFolderData(res.item)
                        console.log(folderData)
                        store.state.user.folder.data = folderData
                        //this.handleSetTree(res.datas)
                    } else {
                        console.log(res.rltdesc)
                        //reject(res.rltdesc)
                    }
                } else {
                    console.log(res.rtndesc)
                    //reject(res.rtndesc)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        setFolderData(items) {
            let data = {}
            data.header = [{
                title: "文件夹名称",
                key: "filename",
                align: "left"
            }]
            data.tabname = 'tbl'
            data.pageindex = 1
            data.total = 10
            data.tabrows = []
            if (items !== undefined && items.length > 0) {
                for (var item of items) {
                    var row = {}
                    row.foldername = item.dir_name
                    row.folderid = item.dir_id
                    row.filetype = 2
                    row.desc = ""
                    row.parent_dir_id = item.parent_dir_id
                    row.is_root = item.is_root
                    row.is_fixed = item.is_fixed
                    row._checked = false
                    row._disabled = false
                    data.tabrows.push(row)
                }
            }
            return data
        },

        handle_lefttree() {
            constJ.ReqGetLeftTree().then(res => {
                //onsole.log("ReqGetLeftTree...")
                //console.log(res)
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //console.log(res.datas)
                        this.handleSetTree(res.datas)
                    } else {
                        //reject(res.rltdesc)
                    }
                } else {
                    //reject(res.rtndesc)
                }
            }).catch(err => {
                //reject(err)
                console.log(err)
            })
        },

        handle_lefttmtree() {
            constJ.ReqGetTMLeftTree().then(res => {
                //console.log("handle_lefttmtree...")
                //res= JSON.parse(JSON.stringify(res))
                //let resObj=JSON.parse(JSON.stringify(res))
                //console.log(resObj)
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //console.log()
                        let result = JSON.parse(JSON.stringify(res.datas))
                        this.handleSetTMTree(result)
                    } else {
                        //reject(res.rltdesc)
                    }
                } else {
                    //reject(res.rtndesc)
                }
            }).catch(err => {
                //reject(err)
                console.log(err)
            })
        },

        handle_industry() {
            constJ.reqGetIndustry().then(res => {
                // console.log("行业")
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //this.industry=res.datas;
                        this.handleSetIndustry(res.datas);
                    }
                }
                //console.log(res)
            }).catch(err => {
                console.log(err)
            })
        },
        handle_taxes() {
            constJ.reqGetTaxes().then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //this.cList=res.datas;
                        this.handleSetTax(res.datas);
                    }
                }
                //console.log(res)
            }).catch(err => {
                console.log(err)
            })
        },
        handle_inOut() {
            constJ.reqGetInOut().then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //this.cList=res.datas;
                        this.handleSetInOut(res.datas);
                    }
                }
                //console.log(res)
            }).catch(err => {
                console.log(err)
            })
        },

        //reqGetReduction
        handle_Reduction() {
            constJ.reqGetReduction().then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //console.log(res.datas)
                        //this.cList=res.datas;
                        this.handleSetReduction(res.datas);
                    }
                }
                //console.log(res)
            }).catch(err => {
                console.log(err)
            })
        },

        //reqGetReduction_tax
        handle_Reduction_tax() {
            constJ.reqGetReduction_tax().then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //console.log(res.datas)
                        //this.cList=res.datas;
                        this.handleSetReduction_tax(res.datas);
                    }
                } else {
                    console.log(res)
                }

            }).catch(err => {
                console.log(err)
            })
        },

        ////reqGetReduction_tax
        handle_Reduction_industry() {
            constJ.reqGetReduction_industry().then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //console.log(res.datas)
                        this.handleSetReduction_industry(res.datas);
                    }
                }
                //console.log(res)
            }).catch(err => {
                console.log(err)
            })
        },


        handle_country() {
            constJ.reqGetCountry().then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //this.cList=res.datas;
                        //console.log(res.datas)
                        this.handleSetCountry(res.datas);
                    }
                }
                //console.log(res)
            }).catch(err => {
                console.log(err)
            })
        },

        handle_ProvinceAndCity() {
            constJ.reqGetProvinceAndCity().then(res => {
                //console.log('22222==========>')
                console.log(res)
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //console.log(res.datas)
                        this.handleSetProvinceCity(res.datas);
                    }
                }
                //console.log(res)
            }).catch(err => {
                console.log(err)
            })
        },

        //获取优惠行业列表
        handle_OffersIndustry() {
            constJ.reqGetOffersIndustry().then(res => {
                console.log(res)
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        let allIndustryItem={
                           industryid:'000000',
                           title:'所有行业'
                        }
                        let industrylist=res.item
                        industrylist.unshift(allIndustryItem)
                        console.log(industrylist)
                        this.handleSetOffers_industry(industrylist);
                    }
                }
                //console.log(res)
            }).catch(err => {
                console.log(err)
            })
        },

        ...mapActions([
            'handleTempLogin', 'handleSetIndustry', 'handleSetTax', 'handleSetTree', 'handleSetTMTree', 'handleSetInOut', 'handleSetReduction', 'handleSetReduction_tax', 'handleSetReduction_industry', 'handleSetCountry', 'handleSetProvinceCity', 'handleSetOffers_industry'
        ]),
        //固定文件夹
        initFolder() {
            let data2 = {
                header: [{
                    "title": "文件夹名称",
                    "key": "filename",
                    "align": "left"
                }],
                tabrows: [{
                        "foldername": "文件夹1",
                        "folderid": "001001",
                        "filetype": 2,
                        'desc': '',
                        '_checked': false,
                        '_disabled': false,
                    },
                    {
                        "foldername": "文件夹2",
                        "folderid": "001002",
                        "filetype": 2,
                        'desc': '',
                        '_checked': false,
                        '_disabled': false,
                    },
                    {
                        "foldername": "文件夹3",
                        "folderid": "001003",
                        "filetype": 2,
                        'desc': '',
                        '_checked': false,
                        '_disabled': false,
                    }
                ],
                tabname: 'tbl',
                pageindex: 1,
                total: 10
            }
            return data2
        },
        checkUserLogin() {
            //console.log(store.state.user.userId)
            if (store.state.user.userId === undefined || store.state.user.userId === "") {
                return false
            } else {
                return true
            }
        },
    },
    computed: {
        ...mapGetters(['sta', 'getUserId'])
    },
    components: {

    },
    watch: {
        '$route': function(val, oldVal) {
            //console.log(this.$route)
            //监听t状态,0=临时登录
            if (this.$route.query.t === 0) {
                //console.log("监听到临时登录...")
                this.load();
            }
            //console.log(this.$route.query.t)
            //console.log(val,oldVal);
            // console.log('route...');
        },
        getUserId: function(value) {
            //监听用户是否登录，如果登录成功则初始化固定文件夹
            //可能会导致重复添加文件夹
            if (this.checkUserLogin()) {
                setTimeout(() => {
                    this.initUserFolder()
                    //this.getAllFolder()
                }, 3000);

            }
            //console.log(value)
        }

    },
    beforeCreate() {
        // this.handleTempLogin()
        //   .then(res => {
        //     console.log('before...')
        //   })
    }
}
</script>
<style scoped>
body {
    height: 100%;
    width: 100%;
}

/*#app{
  font-size: 12px;
}*/
</style>